"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportType = void 0;
var SupportType;
(function (SupportType) {
    SupportType["technical"] = "technical";
    SupportType["clinical"] = "clinical";
})(SupportType = exports.SupportType || (exports.SupportType = {}));
